import React, {
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TextField } from 'mui-rff';
import { Form } from 'react-final-form';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  makeStyles,
} from '@material-ui/core';
import SearchBar from 'material-ui-search-bar';
import FilterIcon from '@material-ui/icons/FilterList';
import PostAddIcon from '@material-ui/icons/PostAdd';

import { pageStatusValues, pageTypeValues } from 'src/utils/enums';
import pagesSelectors from 'src/store/selectors/pages';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  filters: {
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    background: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      background: theme.palette.primary.dark,
    }
  },
  filtersActive: {
    background: theme.palette.primary.dark,
  },
  filtersActions: {
    justifyContent: 'center',
  },
  searchBar: {
    flex: 1,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  searchBarContainer: {
    display: 'flex',
  },
}));

const Toolbar = ({ handleSearch }) => {
  const classes = useStyles();
  const [isFiltersOpen, setFiltersOpen] = useState(false);

  const filters = useSelector((state) => pagesSelectors.getFilters(state));

  useEffect(() => {
    setFiltersOpen(Object.keys(filters).length > (filters.search ? 1 : 0));
  }, [filters]);

  const handleFilter = (values = {}) => {
    handleSearch(values);
  };

  const handleSearchInputChange = (value) => {
    const filtersArray = {
      ...filters,
    };

    if (value) {
      filtersArray.search = value;
    } else {
      delete filtersArray.search;
    }

    handleFilter(filtersArray);
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
    >
      <Grid
        item
        md={6}
        xs={12}
      >
        <Box className={classes.searchBarContainer}>
          <SearchBar
            className={classes.searchBar}
            onRequestSearch={handleSearchInputChange}
            onCancelSearch={handleSearchInputChange}
            placeholder="Szukaj strony"
            value={filters.search || ''}
          />
          <IconButton
            color="secondary"
            className={clsx(classes.filters, isFiltersOpen && classes.filtersActive)}
            onClick={() => setFiltersOpen(!isFiltersOpen)}
            variant="contained"
          >
            <FilterIcon />
          </IconButton>
        </Box>
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
      >
        <Box display="flex" justifyContent="flex-end">
          <Button
            color="secondary"
            component={RouterLink}
            startIcon={<PostAddIcon />}
            to="/page/add"
            variant="contained"
          >
            Dodaj stronę
          </Button>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
      >
        <Collapse in={isFiltersOpen}>
          <Form
            initialValues={filters}
            keepDirtyOnReinitialize
            onSubmit={handleFilter}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit} noValidate>
                <Card>
                  <CardContent>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid
                        item
                        md={6}
                        xs={12}
                      >
                        <TextField
                          fullWidth
                          label="Typ"
                          name="type"
                          select
                          variant="outlined"
                        >
                          <MenuItem value="">
                            Wszystkie
                          </MenuItem>
                          {pageTypeValues.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid
                        item
                        md={6}
                        xs={12}
                      >
                        <TextField
                          fullWidth
                          label="Status"
                          name="status"
                          select
                          variant="outlined"
                        >
                          <MenuItem value="">
                            Wszystkie
                          </MenuItem>
                          {pageStatusValues.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                          <MenuItem value="deleted">
                            Usunięty
                          </MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Divider />
                  <CardActions className={classes.filtersActions}>
                    <Button
                      color="secondary"
                      size="small"
                      type="submit"
                      variant="contained"
                    >
                      Filtruj
                    </Button>
                    <Button
                      onClick={() => {
                        if (filters.search) {
                          handleFilter({ search: filters.search });
                        } else {
                          handleFilter();
                        }
                      }}
                      size="small"
                      type="reset"
                    >
                      Wyczyść
                    </Button>
                  </CardActions>
                </Card>
              </form>
            )}
          />
        </Collapse>
      </Grid>
    </Grid>
  );
};

Toolbar.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};

export default Toolbar;
